import React from 'react';
import { ReactComponent as IconBack } from '../../assets/icons/back.svg';
import { getFixedHeight } from '../../utils';

export default function Page({ title, children }){
    return (
        <div className="page">
            <div className="navbar-top">
                <IconBack className="back-button" onClick={() => window.history.back()} />
                <div className="title">{title}</div>
                {/* <div className="spacer"></div> */}
            </div>

            <div className="page-body"  style={{height: `calc(100dvh - ${(getFixedHeight() + 50)}px)`, overflowY: 'auto', width: '100%'}}>
                {children}
            </div>
        </div>
    );
}